import React from "react";
import { useTranslation } from "react-i18next";
import { ShimmerDiv } from "./ThemedShimmer";

const ListRowSkeleton = ({
  count = 5,
  rowHeight = 56,
  showAvatar = false,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`skeleton-list ${className} m-2`.trim()}
      role="status"
      aria-busy="true"
      aria-label={t("Common.LoadingList")}
    >
      <span className="skeleton-screen-reader-only">{t("Common.LoadingList")}</span>
      {Array.from({ length: count }, (_, index) => (
        <div className="d-flex align-items-center gap-2" key={`list-skeleton-${index}`}>
          {showAvatar && <ShimmerDiv height={40} width={40} rounded={50} />}
          <ShimmerDiv
            className="mb-1 flex-grow-1"
            height={rowHeight}
            width="100%"
            rounded={8}
          />
        </div>
      ))}
    </div>
  );
};

export default ListRowSkeleton;
